import { Action, createReducer, on } from '@ngrx/store';
import {
  IBusinessUserRolesRequest,
  IBusinessUserRolesResponse,
  LegalEntityPermissions
} from '../models/business-user-roles.model';
import * as authActions from '../actions';

export const businessUserRoleFeatureKey = 'businessUserRole';

export interface BusinessUserRoleState {
  loadBusinessUserRolesRequest: IBusinessUserRolesRequest;
  loadBusinessUserRolesRequestSuccess: IBusinessUserRolesResponse;
  loadBusinessUserRolesRequestFailure: Error | any;
  permissions?: string[];
  legalEntityPermissions?: { [legalEntityId: string]: LegalEntityPermissions };
  currentLegalEntityId?: string;
}

export const initialState: BusinessUserRoleState = {
  loadBusinessUserRolesRequest: undefined,
  loadBusinessUserRolesRequestSuccess: undefined,
  loadBusinessUserRolesRequestFailure: undefined,
  permissions: undefined,
  legalEntityPermissions: undefined,
  currentLegalEntityId: undefined
};

export const reducer = createReducer(
  initialState,
  on(authActions.loadBusinessUserRoles, (state, action) => ({
    ...state,
    loadBusinessUserRolesRequest: action.request,
    currentLegalEntityId: action.request?.businessId || undefined
  })),
  on(authActions.loadBusinessUserRolesSuccess, (state, action) => ({
    ...state,
    loadBusinessUserRolesRequestSuccess: action.response,
    permissions: action.response?.permissions || [],
    legalEntityPermissions: action.response?.legalEntityPermissions || undefined
  })),
  on(authActions.loadBusinessUserRolesFailure, (state, action) => ({
    ...state,
    loadBusinessUserRolesRequestFailure: action.error
  }))
);

export const getBusinessUserRoles = (state: BusinessUserRoleState) => state.loadBusinessUserRolesRequestSuccess;
